<template>
  <Instance
    instance="year"
    instance-name="year"
    :create="d => yearApi.create(d)"
    :delete="d => yearApi.remove(d)"
    :update="d => yearApi.update(d)"
    :get="d => yearApi.get(d)"
    :upsert="upsert"
    :columns="columns"
    :hideDelete="!isCommonAdmin"
  />
</template>

<script>

import Instance from '../../CRUD/instance';
import { AuthMixin } from '../../../../mixins';
import api from '../../../api';

export default {
  title: 'Years',
  components: { Instance },
  mixins: [AuthMixin],
  data() {
    return {
      yearApi: api.year,
      upsert: [
        { value: 'year', name: 'Year', required: true },
      ],
    };
  },
  methods: {
    columns() {
      return [
        {
          field: 'check',
          key: 'check',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center'
        },
        {
          field: 'year',
          title: this.$translate('Year'),
          key: 'year',
          align: 'left'
        },
      ];
    }
  }
};
</script>
